export default "__VITE_ASSET__4c44e3b5__"